var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1236)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 4C4.00004 6.20913 5.79091 8 8.00004 8C10.2092 8 12 6.20913 12 4C12 1.79086 10.2092 0 8.00004 0C5.79091 0 4.00004 1.79086 4.00004 4ZM11.3334 4C11.3334 5.84093 9.84097 7.33333 8.00004 7.33333C6.15911 7.33333 4.66671 5.84093 4.66671 4C4.66671 2.15905 6.15911 0.666667 8.00004 0.666667C9.84097 0.666667 11.3334 2.15905 11.3334 4ZM2.00004 16C2.00004 12.6863 4.68634 10 8.00004 10C11.3137 10 14 12.6863 14 16H14.6667C14.6667 12.3181 11.6819 9.33333 8.00004 9.33333C4.31814 9.33333 1.33337 12.3181 1.33337 16H2.00004Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_1236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00004 4C4.00004 6.20913 5.79091 8 8.00004 8C10.2092 8 12 6.20913 12 4C12 1.79086 10.2092 0 8.00004 0C5.79091 0 4.00004 1.79086 4.00004 4ZM11.3334 4C11.3334 5.84093 9.84097 7.33333 8.00004 7.33333C6.15911 7.33333 4.66671 5.84093 4.66671 4C4.66671 2.15905 6.15911 0.666667 8.00004 0.666667C9.84097 0.666667 11.3334 2.15905 11.3334 4ZM2.00004 16C2.00004 12.6863 4.68634 10 8.00004 10C11.3137 10 14 12.6863 14 16H14.6667C14.6667 12.3181 11.6819 9.33333 8.00004 9.33333C4.31814 9.33333 1.33337 12.3181 1.33337 16H2.00004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ad3b173c2b41096c069c51c18e7655c2.svg";
export { ForwardRef as ReactComponent };